import * as Sentry from '@sentry/react';

const isProdEnv = process.env.NODE_ENV === 'production';

if (isProdEnv) {
  Sentry.init({
    dsn: 'https://b9ff14df65ba47aea01e72221f5d1030@o486889.ingest.sentry.io/4505091831431168',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1
  });
}
